<template>
    <div>
        <!-- Footer Area -->
        <div class="footer-area">
            <div class="footer-top pt-0 text-center">
                <div class="container mt-3">
                    <a class="main-logo" href="https://www.travelplaces.co.uk" target="_blank">
                        <img src="assets/img/brand/logo.travelplaces.tagline.white_.svg" width="180px"
                            data-lazy-src="assets/img/brand/logo.travelplaces.tagline.white_.svg" alt="Travel Places">
                    </a>
                    <a class="dark-logo" href="https://www.travelplaces.co.uk" target="_blank">
                        <img src="assets/img/brand/logo.travelplaces.tagline.white_.svg" width="180px"
                            data-lazy-src="assets/img/brand/logo.travelplaces.tagline.white_.svg" alt="Travel Places">
                    </a>
                    <p>&copy; {{ new Date().getFullYear() }}</p>

                </div>
            </div>
            <div v-if="this.user" class="container">
                <div class="footer-bottom text-center">
                    <ul>
                        <li>
                            <a @click="$router.push('/')">
                                <img src="assets/img/icon/23.png" alt="img">
                            </a>
                        </li>
                        <li>
                            <a class="menu-bar" @click="$store.state.sidebarMinimize = !$store.state.sidebarMinimize"
                                href="#">
                                <img src="assets/img/icon/26.png" alt="img">
                            </a>
                        </li>

                        <li>
                            <a class="ba-add-balance-btn" href="#" title="Back to top">
                                <!-- <img src="assets/img/icon/27.png" alt="img"> -->
                                <i class="fa fa-angle-up text-primary fa-3x mt-1"></i>
                            </a>
                        </li>
                        <li>
                            <a @click="$router.push('/settings')">
                                <img src="assets/img/icon/24.png" alt="img">
                            </a>
                        </li>
                        <li>
                            <a @click="$router.push('/logout')">
                                <i class="fa fa-sign-out fa-lg text-success"></i>
                                <!-- <img src="assets/img/icon/25.png" alt="img"> -->
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
        <!-- footer End -->
        <!-- back to top area start -->
        <div class="back-to-top">
            <span class="back-top"><i class="fa fa-angle-up"></i></span>
        </div>
        <!-- back to top area end -->
    </div>
</template>
<script>
export default {
    name: "TheFooter",
};
</script>